module.exports = __webpack_public_path__ + "media/images/menu/phobos-7d2a27e763707627cb3d4b379c32c8c8.jpg";